import Companies from './views/Companies';
import Company from './views/Company'

export default {
  routes: [
    {
      path: '/module/companies',
      name: 'Companies',
      component: Companies,
      meta: {tab: 'companies', setting_link: 'Companies'}
    },
    {
      path: '/module/companies/:company_id',
      name: 'Company',
      components: {default: Companies, right: Company},
      meta: {tab: 'companies', setting_link: 'Companies'}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/modules/companies/routes.js